export default __webpack_public_path__ + "resolution_rate_ratio_formula.png";